import { generatePath } from 'react-router-dom';
import { APIRoutes } from '../../routes';
import apiInstance from '../index';

export interface NmiTemplateDto {
    id: string;
    code: string | null;
    label: string;
    body: string;
    isActive: boolean;
    createdBy: string;
    modifiedBy: string;
    dateCreated: string;
    dateModified: string;
    rowVersion: number;
}

export interface CreateNmiTemplateRequest {
    label: string;
    body: string;
}

export interface UpdateNmiTemplateRequest {
    label: string;
    body: string;
    isActive: boolean;
    rowVersion: number;
}

export interface NmiTemplatePreviewResponse {
    renderedText: string;
    validationErrors: string[];
}

export const getNmiTemplates = async (): Promise<NmiTemplateDto[]> =>
    (await apiInstance.get<NmiTemplateDto[]>(APIRoutes.NMI_TEMPLATES)).data;

export const getNmiTemplatePlaceholders = async (): Promise<string[]> =>
    (await apiInstance.get<string[]>(APIRoutes.NMI_TEMPLATES_PLACEHOLDERS)).data;

export const createNmiTemplate = async (request: CreateNmiTemplateRequest): Promise<NmiTemplateDto> =>
    (await apiInstance.post<NmiTemplateDto>(APIRoutes.NMI_TEMPLATES, request)).data;

export const updateNmiTemplate = async (
    id: string,
    request: UpdateNmiTemplateRequest,
): Promise<NmiTemplateDto> => {
    const endpointUrl = generatePath(APIRoutes.NMI_TEMPLATE_BY_ID, { id });
    return (await apiInstance.put<NmiTemplateDto>(endpointUrl, request)).data;
};

export const previewNmiTemplate = async (body: string): Promise<NmiTemplatePreviewResponse> =>
    (await apiInstance.post<NmiTemplatePreviewResponse>(APIRoutes.NMI_TEMPLATES_PREVIEW, { body })).data;
